import moment from 'moment';

export const getCurrentPeriod = (monthlyCycleStartDay, date = new Date()) => {
    const currentDate = new Date(date);
    const currentPeriodStart = new Date(date);
    currentPeriodStart.setDate(monthlyCycleStartDay || 1);

    if (currentDate < currentPeriodStart) {
        currentPeriodStart.setMonth(currentPeriodStart.getMonth() - 1);
    }

    const currentPeriodEnd = new Date(currentPeriodStart);
    currentPeriodEnd.setMonth(currentPeriodEnd.getMonth() + 1);

    return [currentPeriodStart, currentPeriodEnd];
};

export const periodToString = (period) => {
    return period.map(date => moment(date).format('DD-MM-YYYY')).join(' - ');
};

export const dateToPeriodString = (date) => {
    return `${moment(date).format('DD/MM/YYYY')} - ${moment(date).add(1, 'month').format('DD/MM/YYYY')}`;
};
